
/* styles */
require("!!../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-3fa4059e\",\"scoped\":true,\"hasInlineConfig\":false}!./style/crop.css")

var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./crop.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3fa4059e\"}!../../vue-loader/lib/selector?type=template&index=0!./crop.vue"),
  /* scopeId */
  "data-v-3fa4059e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-core-image-upload/dist/crop.vue
// module id = 784
// module chunks = 0